import { AccessTokenJsConstantsCrossModel } from "../models/index";
export const baseUrl = window.localStorage.getItem(AccessTokenJsConstantsCrossModel.webApiUrl);
